import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { Backdrop, Drawer } from '@material-ui/core';

import useSideNavState from '../../stores/SideNavStateStore';
import useStyles from './SideNavStyles';
import NavigationMenuContainer from './management/NavigationMenuContainer';

export default function SideNav() {
    const [sideNavState, sideNavStateActions] = useSideNavState();
    const theme = useTheme();
    const classes = useStyles();
    const location = useLocation();

    useEffect(() => {
        if (sideNavState.floating) sideNavStateActions.setOpen(false);
        // This both depends upon and changes sideNavState, so don't include it in the dependencies.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <Drawer
            className={clsx('flex-container', classes.root, {
                floating: sideNavState.floating,
            })}
            variant="persistent"
            anchor="left"
            open={sideNavState.open}
        >
            <div id="side-nav" className={clsx('scroll-container', classes.scrollContainer)}>
                <NavigationMenuContainer />
            </div>

            <div className={clsx('flex-container', classes.footer)}>
                <img className={classes.companyLogo} src={theme.companyLogo} alt={theme.companyName} />
            </div>
            <Backdrop
                open={sideNavState.floating && sideNavState.open}
                onClick={() => sideNavStateActions.setOpen(false)}
            />
        </Drawer>
    );
}
